import { useNavigate } from "react-router-dom";
import { saveUser } from "../utils/auth";
import Login from "../Login";

export default function LoginPage() {
  const navigate = useNavigate();

  const handleLogin = (loggedUser) => {
    saveUser(loggedUser);
    navigate('/editor');
  };

  return <Login onLogin={handleLogin} onGoHome={() => navigate('/')} />;
}